import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { CourseFeedbackRoutingModule } from './course-feedback-routing.module';
import { CourseFeedbackListComponent } from './course-feedback-list/course-feedback-list.component';
import { CourseFeedbackViewComponent } from './course-feedback-view/course-feedback-view.component';

@NgModule({
  declarations: [CourseFeedbackListComponent, CourseFeedbackViewComponent],
  imports: [
    CommonModule,
    CourseFeedbackRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class CourseFeedbackModule { }
